var _rect, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0, _ellipse1, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _line, _line2, _line3, _path, _line4, _line5, _line6, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossml(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 148,
    height: 30,
    viewBox: "0 0 148 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.25293,
    width: 27.9315,
    height: 27.9051,
    rx: 2.64503,
    fill: "#F44334"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.13796,
    cy: 11.0051,
    rx: 2.1028,
    ry: 2.1028,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.17877,
    cy: 11.0186,
    rx: 0.952211,
    ry: 0.952212,
    fill: "#F44334"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.5713,
    cy: 8.35937,
    rx: 1.70605,
    ry: 1.70605,
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.6029,
    cy: 8.3705,
    rx: 0.772845,
    ry: 0.772845,
    fill: "#F44334"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.1142,
    cy: 5.79394,
    rx: 1.70605,
    ry: 1.70605,
    fill: "white"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.1459,
    cy: 5.80507,
    rx: 0.772845,
    ry: 0.772845,
    fill: "#F44334"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.7479,
    cy: 14.2323,
    rx: 1.97055,
    ry: 1.97055,
    fill: "white"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.7869,
    cy: 14.2449,
    rx: 0.892324,
    ry: 0.892324,
    fill: "#F44334"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.5387,
    cy: 21.5201,
    rx: 1.74572,
    ry: 1.74572,
    fill: "white"
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.5701,
    cy: 21.532,
    rx: 0.790818,
    ry: 0.790818,
    fill: "#F44334"
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.3792,
    cy: 23.846,
    rx: 1.95732,
    ry: 1.95732,
    fill: "white"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.4176,
    cy: 23.858,
    rx: 0.886335,
    ry: 0.886335,
    fill: "#F44334"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.90849,
    cy: 17.8167,
    rx: 1.95732,
    ry: 1.95732,
    fill: "white"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.94688,
    cy: 17.8287,
    rx: 0.886335,
    ry: 0.886335,
    fill: "#F44334"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.2454,
    cy: 14.7874,
    rx: 1.81185,
    ry: 1.81185,
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 13.6422,
    x2: 19.4436,
    y2: 6.7122,
    stroke: "white",
    strokeWidth: 1.05801
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 13.9082,
    y1: 13.9056,
    x2: 12.2004,
    y2: 9.80698,
    stroke: "white",
    strokeWidth: 1.05801
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 13.1426,
    y1: 14.4217,
    x2: 6.10684,
    y2: 11.7237,
    stroke: "white",
    strokeWidth: 1.05801
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5664 14.244L14.9039 14.5879",
    stroke: "white",
    strokeWidth: 1.05801
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 14.3769,
    y1: 14.3546,
    x2: 12.737,
    y2: 22.1073,
    stroke: "white",
    strokeWidth: 1.05801
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 14.3935,
    y1: 14.1706,
    x2: 9.50023,
    y2: 17.0537,
    stroke: "white",
    strokeWidth: 1.05801
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 22.473,
    y1: 20.7104,
    x2: 15.1462,
    y2: 15.6055,
    stroke: "white",
    strokeWidth: 1.05801
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7861 29.3315C39.6258 29.3315 38.6035 29.1473 37.7194 28.779C36.8538 28.4106 36.117 27.8949 35.5092 27.2318C34.9198 26.5688 34.4778 25.786 34.1831 24.8835C33.8884 23.9625 33.741 22.9495 33.741 21.8444C33.741 20.7393 33.8976 19.7263 34.2107 18.8053C34.5423 17.8844 35.0027 17.0924 35.5921 16.4294C36.1815 15.7479 36.8998 15.2229 37.7471 14.8546C38.6127 14.4678 39.5705 14.2744 40.6204 14.2744C41.265 14.2744 41.9097 14.3296 42.5543 14.4402C43.199 14.5507 43.816 14.7256 44.4054 14.9651L43.8252 17.1477C43.4384 16.9635 42.9871 16.8161 42.4714 16.7056C41.9741 16.5951 41.44 16.5399 40.869 16.5399C39.4324 16.5399 38.3273 16.9911 37.5537 17.8936C36.7985 18.7961 36.4209 20.1131 36.4209 21.8444C36.4209 22.618 36.5038 23.3271 36.6696 23.9717C36.8538 24.6164 37.1301 25.1689 37.4984 25.6294C37.8852 26.0899 38.3733 26.449 38.9627 26.7069C39.5521 26.9463 40.2704 27.0661 41.1177 27.0661C41.7992 27.0661 42.4162 27.0016 42.9687 26.8727C43.5213 26.7437 43.9541 26.6056 44.2672 26.4582L44.6264 28.6132C44.479 28.7053 44.2672 28.7974 43.991 28.8895C43.7147 28.9632 43.4016 29.0276 43.0516 29.0829C42.7017 29.1566 42.3241 29.2118 41.9189 29.2487C41.5321 29.3039 41.1545 29.3315 40.7861 29.3315ZM52.6894 14.3296C52.9104 14.3296 53.1591 14.3481 53.4353 14.3849C53.73 14.4033 54.0155 14.4402 54.2918 14.4954C54.5681 14.5323 54.8167 14.5783 55.0378 14.6336C55.2772 14.6704 55.4522 14.7072 55.5627 14.7441L55.1206 16.9819C54.918 16.9082 54.5773 16.8254 54.0984 16.7333C53.6379 16.6228 53.0393 16.5675 52.3026 16.5675C51.8237 16.5675 51.3448 16.6228 50.866 16.7333C50.4055 16.8254 50.1016 16.8898 49.9542 16.9267V29H47.3849V15.2414C47.9927 15.0203 48.7478 14.8177 49.6503 14.6336C50.5528 14.4309 51.5659 14.3296 52.6894 14.3296ZM70.7232 21.8168C70.7232 22.9587 70.5574 23.9902 70.2259 24.9111C69.8944 25.832 69.4247 26.624 68.8169 27.2871C68.2275 27.9501 67.5184 28.4659 66.6896 28.8342C65.8607 29.1842 64.9582 29.3592 63.982 29.3592C63.0058 29.3592 62.1033 29.1842 61.2745 28.8342C60.4457 28.4659 59.7274 27.9501 59.1195 27.2871C58.5301 26.624 58.0697 25.832 57.7382 24.9111C57.4066 23.9902 57.2409 22.9587 57.2409 21.8168C57.2409 20.6932 57.4066 19.671 57.7382 18.7501C58.0697 17.8107 58.5301 17.0095 59.1195 16.3465C59.7274 15.6834 60.4457 15.1769 61.2745 14.8269C62.1033 14.4586 63.0058 14.2744 63.982 14.2744C64.9582 14.2744 65.8607 14.4586 66.6896 14.8269C67.5184 15.1769 68.2275 15.6834 68.8169 16.3465C69.4247 17.0095 69.8944 17.8107 70.2259 18.7501C70.5574 19.671 70.7232 20.6932 70.7232 21.8168ZM68.0433 21.8168C68.0433 20.1959 67.6749 18.9159 66.9382 17.9765C66.2199 17.0188 65.2345 16.5399 63.982 16.5399C62.7296 16.5399 61.735 17.0188 60.9982 17.9765C60.2799 18.9159 59.9207 20.1959 59.9207 21.8168C59.9207 23.4376 60.2799 24.7269 60.9982 25.6847C61.735 26.624 62.7296 27.0937 63.982 27.0937C65.2345 27.0937 66.2199 26.624 66.9382 25.6847C67.6749 24.7269 68.0433 23.4376 68.0433 21.8168ZM77.6811 27.1489C78.731 27.1489 79.5045 27.0108 80.0018 26.7345C80.5175 26.4582 80.7754 26.0162 80.7754 25.4084C80.7754 24.7822 80.5268 24.2849 80.0295 23.9165C79.5322 23.5481 78.7125 23.1337 77.5706 22.6732C77.018 22.4522 76.4839 22.2312 75.9682 22.0102C75.4709 21.7707 75.038 21.4945 74.6697 21.1813C74.3013 20.8682 74.0066 20.4906 73.7856 20.0486C73.5646 19.6066 73.454 19.0632 73.454 18.4186C73.454 17.1477 73.9237 16.1439 74.8631 15.4071C75.8024 14.652 77.0825 14.2744 78.7033 14.2744C79.1085 14.2744 79.5137 14.302 79.9189 14.3573C80.3242 14.3941 80.7017 14.4494 81.0517 14.523C81.4016 14.5783 81.7055 14.6428 81.9634 14.7164C82.2397 14.7901 82.4515 14.8546 82.5988 14.9098L82.1292 17.1201C81.8529 16.9727 81.4201 16.8254 80.8307 16.678C80.2413 16.5122 79.5322 16.4294 78.7033 16.4294C77.985 16.4294 77.3588 16.5767 76.8246 16.8714C76.2905 17.1477 76.0234 17.5897 76.0234 18.1975C76.0234 18.5107 76.0787 18.7869 76.1892 19.0264C76.3181 19.2658 76.5023 19.4868 76.7418 19.6894C76.9996 19.8736 77.3127 20.0486 77.6811 20.2144C78.0495 20.3801 78.4915 20.5551 79.0072 20.7393C79.6887 20.9972 80.2965 21.255 80.8307 21.5129C81.3648 21.7523 81.8161 22.0378 82.1844 22.3693C82.5712 22.7009 82.8659 23.1061 83.0685 23.585C83.2711 24.0454 83.3724 24.6164 83.3724 25.2979C83.3724 26.624 82.8751 27.6278 81.8805 28.3093C80.9043 28.9908 79.5045 29.3315 77.6811 29.3315C76.4102 29.3315 75.4156 29.221 74.6973 29C73.979 28.7974 73.4909 28.6408 73.233 28.5303L73.7027 26.3201C73.9974 26.4306 74.4671 26.5964 75.1117 26.8174C75.7564 27.0384 76.6128 27.1489 77.6811 27.1489ZM90.0111 27.1489C91.0609 27.1489 91.8345 27.0108 92.3318 26.7345C92.8475 26.4582 93.1054 26.0162 93.1054 25.4084C93.1054 24.7822 92.8567 24.2849 92.3594 23.9165C91.8621 23.5481 91.0425 23.1337 89.9006 22.6732C89.348 22.4522 88.8139 22.2312 88.2981 22.0102C87.8008 21.7707 87.368 21.4945 86.9996 21.1813C86.6313 20.8682 86.3366 20.4906 86.1156 20.0486C85.8945 19.6066 85.784 19.0632 85.784 18.4186C85.784 17.1477 86.2537 16.1439 87.193 15.4071C88.1324 14.652 89.4125 14.2744 91.0333 14.2744C91.4385 14.2744 91.8437 14.302 92.2489 14.3573C92.6541 14.3941 93.0317 14.4494 93.3817 14.523C93.7316 14.5783 94.0355 14.6428 94.2934 14.7164C94.5697 14.7901 94.7815 14.8546 94.9288 14.9098L94.4591 17.1201C94.1829 16.9727 93.75 16.8254 93.1606 16.678C92.5712 16.5122 91.8621 16.4294 91.0333 16.4294C90.315 16.4294 89.6887 16.5767 89.1546 16.8714C88.6205 17.1477 88.3534 17.5897 88.3534 18.1975C88.3534 18.5107 88.4087 18.7869 88.5192 19.0264C88.6481 19.2658 88.8323 19.4868 89.0717 19.6894C89.3296 19.8736 89.6427 20.0486 90.0111 20.2144C90.3794 20.3801 90.8215 20.5551 91.3372 20.7393C92.0187 20.9972 92.6265 21.255 93.1606 21.5129C93.6948 21.7523 94.146 22.0378 94.5144 22.3693C94.9012 22.7009 95.1959 23.1061 95.3985 23.585C95.6011 24.0454 95.7024 24.6164 95.7024 25.2979C95.7024 26.624 95.2051 27.6278 94.2105 28.3093C93.2343 28.9908 91.8345 29.3315 90.0111 29.3315C88.7402 29.3315 87.7456 29.221 87.0273 29C86.3089 28.7974 85.8209 28.6408 85.563 28.5303L86.0327 26.3201C86.3274 26.4306 86.797 26.5964 87.4417 26.8174C88.0863 27.0384 88.9428 27.1489 90.0111 27.1489Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9981 15.048C99.5875 14.9006 100.361 14.7441 101.319 14.5783C102.295 14.4125 103.419 14.3296 104.689 14.3296C105.61 14.3296 106.384 14.4586 107.01 14.7164C107.636 14.9559 108.161 15.315 108.585 15.7939C108.714 15.7018 108.916 15.5729 109.193 15.4071C109.469 15.2414 109.81 15.0848 110.215 14.9375C110.62 14.7717 111.071 14.6336 111.569 14.523C112.066 14.3941 112.6 14.3296 113.171 14.3296C114.276 14.3296 115.179 14.4954 115.879 14.8269C116.579 15.1401 117.122 15.5913 117.509 16.1807C117.914 16.7701 118.181 17.47 118.31 18.2804C118.457 19.0908 118.531 19.9749 118.531 20.9327V29H115.962V21.4852C115.962 20.638 115.915 19.9105 115.823 19.3026C115.75 18.6948 115.593 18.1883 115.354 17.7831C115.133 17.3779 114.82 17.0832 114.414 16.899C114.028 16.6964 113.521 16.5951 112.895 16.5951C112.029 16.5951 111.311 16.7148 110.74 16.9543C110.187 17.1753 109.81 17.3779 109.607 17.5621C109.755 18.041 109.865 18.5659 109.939 19.1369C110.012 19.7079 110.049 20.3065 110.049 20.9327V29H107.48V21.4852C107.48 20.638 107.434 19.9105 107.342 19.3026C107.25 18.6948 107.084 18.1883 106.844 17.7831C106.623 17.3779 106.31 17.0832 105.905 16.899C105.518 16.6964 105.021 16.5951 104.413 16.5951C104.155 16.5951 103.879 16.6043 103.584 16.6228C103.29 16.6412 103.004 16.6688 102.728 16.7056C102.47 16.7241 102.231 16.7517 102.01 16.7885C101.788 16.8254 101.641 16.853 101.567 16.8714V29H98.9981V15.048ZM127.105 29.2763C125.521 29.2394 124.397 28.8987 123.734 28.254C123.071 27.6094 122.739 26.6056 122.739 25.2426V8.00288L125.309 7.56084V24.8282C125.309 25.2518 125.346 25.6018 125.419 25.8781C125.493 26.1543 125.613 26.3754 125.778 26.5411C125.944 26.7069 126.165 26.8358 126.442 26.9279C126.718 27.0016 127.059 27.0661 127.464 27.1213L127.105 29.2763Z",
    fill: "#F44334"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossml);
export default __webpack_public_path__ + "static/media/crossml.62641f98932be84087fb473e5a72cb09.svg";
export { ForwardRef as ReactComponent };